import { Text } from '@ltvco/refresh-lib/theme';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Warning from '@mui/icons-material/Warning';

import { hasFailedMot, hasOutstandingRecalls } from './utils';

import type { ReportMenuItem, UKAutomobile } from '@ltvco/refresh-lib/v2';
import type { ReactNode } from 'react';

const NAV_CLEAN_ICON = (
  <CheckCircle sx={{ color: 'success.main', fontSize: 24 }} />
);
const NAV_WARNING_ICON = <Warning sx={{ color: 'error.main', fontSize: 24 }} />;

const statusTrailingIcons = (isWarning: boolean): [ReactNode, ReactNode] => [
  null,
  isWarning ? NAV_WARNING_ICON : NAV_CLEAN_ICON,
];

const countTrailingIcons = (count: number): [ReactNode, ReactNode] => [
  null,
  <Text
    color="text.primary"
    fontWeight="inherit"
    textAlign="center"
    width="24px"
  >
    {count}
  </Text>,
];

export const getUkNavItems = (automobile: UKAutomobile): ReportMenuItem[] => [
  { href: '#uk-vehicle-overview', labelText: 'Overview' },
  {
    href: '#keeper-history',
    labelText: 'Keeper History',
    icons: countTrailingIcons(automobile.ownership_history.length),
    showIcon: true,
  },
  {
    href: '#mot',
    labelText: 'MOT',
    icons: statusTrailingIcons(hasFailedMot(automobile)),
    showIcon: true,
  },
  {
    href: '#write-off-salvage',
    labelText: 'Write-off & Salvage',
    icons: statusTrailingIcons(automobile.auctions.length > 0),
    showIcon: true,
  },
  {
    href: '#finance-check',
    labelText: 'Finance Check',
    icons: statusTrailingIcons(automobile.liens.length > 0),
    showIcon: true,
  },
  {
    href: '#stolen-check',
    labelText: 'Stolen Check',
    icons: statusTrailingIcons(automobile.thefts.length > 0),
    showIcon: true,
  },
  {
    href: '#safety-recalls',
    labelText: 'Safety Recalls',
    icons: statusTrailingIcons(hasOutstandingRecalls(automobile)),
    showIcon: true,
  },
];
